/* eslint-disable camelcase */
import React from "react"
import { accessLevelDescription } from "utils/accessLevelHelpers"
import { auditShape } from "utils/propTypeShapes"

const AccessLevelGrantUpdatedAuditItemDetails = ({ audit }) => {
  const {
    associatedType, auditedChanges, solutionName,
  } = audit
  const { access_level = [] } = auditedChanges
  const oldAccessLevel = access_level[0]
  const newAccessLevel = access_level[1]

  // access level for none access would be 0
  const hasOldAccessLevel = oldAccessLevel || oldAccessLevel === 0
  const hasNewAccessLevel = newAccessLevel || newAccessLevel === 0

  const renderAccessToObject = () => {
    if (associatedType === "Category") {
      return <span className="font-semibold">made by {solutionName}</span>
    }
    return ""
  }

  return (
    <div>
      Changed an access level grant
      {renderAccessToObject()} { hasOldAccessLevel && ` from ${accessLevelDescription(oldAccessLevel)}` } access
      { hasNewAccessLevel && ` to ${accessLevelDescription(newAccessLevel)}` } access.
    </div>
  )
}

AccessLevelGrantUpdatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default AccessLevelGrantUpdatedAuditItemDetails
